import {
  GET_BILL_DATA,
  GET_BILL_DATA_SUCCESS,
  GET_BILL_DATA_FAILURE,
} from '../actions/billData';

const INITIAL_STATE = { loading: true, cached: false };

export default function billDataReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_BILL_DATA:
      return {
        ...state,
        loading: true,
        cached: true,
      };
    case GET_BILL_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        // API can return balance: null; normalize once here so consumers can assume an object
        billData: {
          ...action.payload,
          balance: (action.payload && action.payload.balance) || {},
        },
      };
    case GET_BILL_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        cached: false,
        error: true,
      };
    default:
      return state;
  }
}
